import CroustilleElement from '../lib/CroustilleElement'

class OrderForm extends CroustilleElement {
  constructor() {
    super('order-form')
  }

  get form() {
    return this.querySelector('form')
  }

  get data() {
    return new FormData(this.form)
  }

  handleFormSubmit(e) {
    e.preventDefault()

    console.log(new URLSearchParams(this.data).toString())

    this.form.submit()
  }

  init() {
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    // this.form.addEventListener('submit', this.handleFormSubmit)
  }

  destroy() {
    // this.form.removeEventListener('submit', this.handleFormSubmit)
  }
}

export default OrderForm
